var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkGray400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33334 4.16699C3.33334 3.50395 3.59673 2.86807 4.06557 2.39923C4.53441 1.93038 5.17029 1.66699 5.83334 1.66699H14.1667C14.8297 1.66699 15.4656 1.93038 15.9344 2.39923C16.4033 2.86807 16.6667 3.50395 16.6667 4.16699V17.5237C16.6667 18.5403 15.5167 19.132 14.69 18.5412L10 15.1912L5.31 18.5412C4.4825 19.1328 3.33334 18.5412 3.33334 17.5245V4.16699ZM5.83334 3.33366C5.61232 3.33366 5.40036 3.42146 5.24408 3.57774C5.0878 3.73402 5 3.94598 5 4.16699V16.7145L9.27334 13.662C9.48536 13.5105 9.73942 13.4291 10 13.4291C10.2606 13.4291 10.5146 13.5105 10.7267 13.662L15 16.7145V4.16699C15 3.94598 14.9122 3.73402 14.7559 3.57774C14.5996 3.42146 14.3877 3.33366 14.1667 3.33366H5.83334Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkGray400);
export default __webpack_public_path__ + "static/media/bookmark_gray400.3c5e2dee8e5ec12e74740bf6845ad5b1.svg";
export { ForwardRef as ReactComponent };